import React, { useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import {
  CloseIcon,
  NotificationNewIcon,
  TrashIcon,
} from "../../../../assets/icons/svgicons";
import sampleAvatar from "../../../../assets/images/sample-profile.png";
import styles from "./NotificationDropdown.module.scss";
import { useDispatch } from "react-redux";
import {
  getUserAllNotificationAction,
  getnotificationReadStatusAction,
} from "../../../../features/user/userSlice";
import {
  getNotificationDataAction,
  deleteNotificationDataAction,
} from "../../../../features/user/userSlice";
import { format } from "date-fns";
import { useEffect } from "react";

const NotificationDropdown = ({
  className,
  disabled,
  hasUnreadNotifications,
  handleReadNotificationList,
  setHasUnreadNotifications,
}) => {
  const toggler = useRef();
  const [notifications, setNotifications] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const dispatch = useDispatch();

  const handleToggle = async (isOpen) => {
    setDropdownOpen(isOpen);

    if (isOpen) {
      try {
        const response = await dispatch(getUserAllNotificationAction());
        if (response.status === 200) {
          setNotifications(response.data.data.notifications);
        }
        const result = await dispatch(getNotificationDataAction());
        // checkUnreadNotifications();
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    }
  };

 

  const handleClick = () => {
    if (toggler.current) {
      toggler.current.click();
    }
    setHasUnreadNotifications(false);
  };

  const handleDelete = async (notificationId) => {
    try {
      const response = await dispatch(
        deleteNotificationDataAction({ data: notificationId })
      );
      if (response.status === 200) {
        setNotifications((prevNotifications) =>
          prevNotifications.filter((item) => item.id !== notificationId)
        );
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  // useEffect(() => {
  //   checkUnreadNotifications();
  // }, []);

  return (
    <Dropdown className={`${className || ""}`} onToggle={handleToggle}>
      <Dropdown.Toggle
        ref={toggler}
        className={`${styles.notify_btn} ${hasUnreadNotifications ? styles.active : ""
          }`}
        // className={`${styles.notify_btn} ${false ? styles.active : ""}`
        disabled={disabled}
      >
        <NotificationNewIcon />
        {hasUnreadNotifications && <span className={styles.red_dot}></span>}
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.notification}>
        <div className={styles.menu_header}>
          <h3>Notification</h3>
          <div className={styles.btnclear}>
            <button
              className={`" w-100 mr-4" ${styles.clear_all}`}
              // onClick={() => handleDelete()}
              onClick={async () => {
                await handleDelete();
                handleClick();
              }}
            >
              Clear All
            </button>

            <button className={styles.btnClose} onClick={handleClick}>
              <CloseIcon />
            </button>
          </div>
        </div>
        <div className={styles.menu_body}>
          <ul>
            {notifications.map((item, index) => (
              <li onClick={handleClick} key={index}>
                {/* <img src={item.icon || sampleAvatar} alt="profile-icon" /> */}
                <div>
                  <div className="d-flex align-items-center">
                    <h6 title={item.title}>{item.title}</h6>
                    <button
                      className={`ms-auto ${styles.trash_btn}`}
                      onClick={() => handleDelete(item.id)}
                    >
                      <TrashIcon />
                    </button>
                  </div>

                  <div className={styles.message_row}>
                    <p className={styles.message_text}>
                      {item.content?.message}
                    </p>
                    <span className={styles.time}>
                      {format(new Date(item.created_at), "dd MMM, yyyy")}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationDropdown;
